/*
<summary>
   This function converts a base64 CSV string (as returned by the crimp/user-created
   inspection export APIs) into a downloadable file and triggers the browser download.
   Developer: Aashish Singh, Created Date: 01-Sep-2026
</summary>
*/

export const downloadCsvFromBase64 = (base64Data: string, fileNamePrefix: string) => {
  const binaryData = atob(base64Data);
  const binaryArray = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    binaryArray[i] = binaryData.charCodeAt(i);
  }
  const blob = new Blob([binaryArray], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileNamePrefix}-${Date.now()}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/**
 * Builds a CSV from headers + rows generated client-side (e.g. an API response array) and
 * triggers the browser download — unlike downloadCsvFromBase64, there's no server-encoded
 * file to decode, just plain values to escape and join. A UTF-8 BOM is prefixed so Excel
 * renders non-ASCII (e.g. Japanese) headers/values correctly.
 */
export const downloadCsvFromRows = (
  headers: string[],
  rows: (string | number)[][],
  fileNamePrefix: string
) => {
  const escapeCell = (value: string | number) => `"${String(value).replace(/"/g, '""')}"`;
  const csvContent = [headers, ...rows]
    .map((row) => row.map(escapeCell).join(','))
    .join('\r\n');
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileNamePrefix}-${Date.now()}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
